import React from "react";

import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import List from "@mui/material/List";
import Alert from "@mui/material/Alert";
import useDialog from "../../hooks/useDialog";
import PropTypes from "prop-types";


const ScoreWarning = (props) => {

    const {attributes} = props
    const scoreDialog = useDialog();

    return <>
            <Alert severity="error" sx={{width: '100%'}} action={
                <Button color="inherit" size="small" onClick={scoreDialog.open}>
                    Dettagli
                </Button>
            }>
                <Typography variant="subtitle2" color="error.main">
                    Mancano alcune informazioni
                </Typography>
            </Alert>

        {
            scoreDialog.show &&
            <Dialog open={true} onClose={scoreDialog.close}>
                <DialogTitle>Mancano le seguenti informazioni</DialogTitle>
                <DialogContent>
                    <List>
                        {
                            attributes.map((a, i) => (
                                <ListItem disablePadding key={i}>
                                    <ListItemIcon>
                                        <WarningIcon color="error"/>
                                    </ListItemIcon>
                                    <ListItemText primary={a}/>
                                </ListItem>
                            ))
                        }
                    </List>
                </DialogContent>
            </Dialog>
        }
    </>
}

ScoreWarning.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.string).isRequired, // the list of attributes without value
};

export default ScoreWarning;